import React, { useEffect } from 'react'
import { CircularProgress, makeStyles, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { fetchReports } from '../../redux/actions/dashboard'
import DashboardSection from './DashboardSection'

// reporty prihlaseneho tenanta - len na citanie (upravuje ich superadmin)

const useStyles = makeStyles((theme) => ({
    table: {
        '& td:first-child, & th:first-child': {
            paddingLeft: theme.spacing(2),
        },
    },
    url: {
        wordBreak: 'break-all',
    },
    centered: {
        padding: theme.spacing(4),
    },
    muted: {
        color: theme.palette.text.secondary,
        fontStyle: 'italic',
    },
}))

export default function Reports() {
    const classes = useStyles()
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const reportsState = useSelector((state: any) => state.reports)
    const tenantId = useSelector((state: any) => state.login.value.user.tenantId)

    useEffect(() => {
        dispatch(fetchReports(tenantId))
    }, [dispatch, tenantId])

    const reports: any[] | null = reportsState.value

    return (
        <DashboardSection title={t('reports.title')} dense>
            <Table size="small" className={classes.table}>
                <TableHead>
                    <TableRow>
                        <TableCell>{t('common.name')}</TableCell>
                        <TableCell>{t('reports.url')}</TableCell>
                        <TableCell>{t('common.description')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {!reports ? (
                        <TableRow>
                            <TableCell colSpan={3} align="center" className={classes.centered}>
                                <CircularProgress size={32} />
                            </TableCell>
                        </TableRow>
                    ) : reports.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={3} className={classes.muted}>
                                {t('dashboard.noReports')}
                            </TableCell>
                        </TableRow>
                    ) : (
                        reports.map((report: any) => (
                            <TableRow key={report.id}>
                                <TableCell>{report.name ?? t('common.none')}</TableCell>
                                <TableCell className={classes.url}>
                                    {report.url ? (
                                        <a href={report.url} target="_blank" rel="noopener noreferrer">
                                            {report.url}
                                        </a>
                                    ) : (
                                        t('common.none')
                                    )}
                                </TableCell>
                                <TableCell>{report.description ?? ''}</TableCell>
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </DashboardSection>
    )
}
